import React, { useEffect, useMemo, useRef, useState } from "react";
import "./UserRegistrationProfile.scss";
import { RedMainHeading } from "../../Global/GlobalText";
import {
  InputLabel,
  InputTextarea,
  InputType,
  SelectBorder,
} from "../../Global/GlobalFormElement";
import {
  GreyBorderButton,
  RedBackgroundButton,
} from "../../Global/GlobalButton";
import { UserTopBanner } from "../../Global/User-Flow/UserTopBanner/UserTopBanner";
import { UserBottomBar } from "../../Global/User-Flow/UserBottomBar/UserBottomBar";
import { useSelector } from "react-redux";
import axios from "axios";
import { EXCHNAGE_URL, USER_EXCHNAGE_URL } from "../../../Url/Url";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import { Modal, Button } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import imageCompression from "browser-image-compression";
import { useLoading } from "../../LoadingContext";

const countries = [
  "United States",
  "Canada",
  "United Kingdom",
  "Australia",
  "India",
  "Germany",
  "France",
  "Italy",
  "Spain",
  "Mexico",
  "Japan",
  "South Korea",
  "Brazil",
  "China",
  "South Africa",
  "Russia",
  "Netherlands",
  "Sweden",
  "Switzerland",
  "Belgium",
];

export const UserRegistrationProfile = ({ form }) => {
  const [formData, setFormData] = useState({});
  const [errors, setErrors] = useState({});
  const [showModal, setShowModal] = useState(true);
  const [formSchema, setFormSchema] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [hasFetched, setHasFetched] = useState(false);
  const [prefillData, setPrefillData] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();
  const {
    eventId,
    registrationFormId,
    entryFormId,
    event_logo,
    event_banner,
    closing_date,
    closing_time,
    event_name,
  } = location.state || {};
  const [isCancelModalOpen, setIsCancelModalOpen] = useState(false);
  const { setLoading } = useLoading();

  const openCancelModal = () => {
    setIsCancelModalOpen(true);
  };

  const closeCancelModal = () => {
    setIsCancelModalOpen(false);
  };

  const handleCancel = () => {
    setFormData({}); // Reset form data
    setIsCancelModalOpen(false);
    toast.info("Form submission canceled.");
    navigate("/user-dashboard");
  };
  const hasFetchedRegistrationForm = useRef(false); // ✅ Create the ref here

  const handleRegistrationForm = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(
        `${EXCHNAGE_URL}/registrationForm?eventId=${eventId}&registrationFormId=${registrationFormId}`,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      if (response.status === 200) {
        const message = response?.data?.message;
        if (message === "Register Already for this event ") {
          navigate("/user-submission-details", {
            state: {
              eventId,
              entryFormId,
              event_logo,
              event_banner,
              closing_date,
              closing_time,
              event_name,
            },
          });
          return;
        }

        const fetchedFields = response.data.data.form_schema;
        const jsonArray = JSON.parse(fetchedFields);
        console.log(jsonArray, "1111");
        setFormSchema(jsonArray);
      } else {
        toast.error("Failed to fetch the registration form.");
      }
    } catch (error) {
      console.error("Error fetching data:", error.message);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (!hasFetchedRegistrationForm.current) {
      hasFetchedRegistrationForm.current = true;

      handleRegistrationForm();
      console.log("hit1")
    }
  }, []);

  const handleCommonDataUser = async () => {
    try {
      setIsLoading(true);

      const response = await axios.get(
        `${USER_EXCHNAGE_URL}/useregistervalueget`,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      if (response.status === 200) {
        const data = response?.data?.data?.[0];
        console.log("Prefill Data:", data);
        setPrefillData(data);
      }
    } catch (error) {
      console.log(error);
    }
    finally {
      setIsLoading(false);
    }
  };

  const hasFetched2 = useRef(false);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (!hasFetched2.current) {
        hasFetched2.current = true;
        handleCommonDataUser();
        console.log("hit2");
      }
    }, 1000);

    return () => clearTimeout(timeoutId);
  }, []);


  const hasPrefilledOnce = useRef(false);

  useEffect(() => {
    if (hasPrefilledOnce.current) return;

    if (!prefillData || formSchema.length === 0) {
      console.log("Prefill data or form schema is empty");
      return;
    }

    setIsLoading(true);
    const timeoutId = setTimeout(() => {

      const updatedFormData = {};


      formSchema.forEach((field) => {
        const dataName = field.dataName;

        if (dataName.startsWith("firstName")) {
          updatedFormData[dataName] = {
            value: prefillData.first_name || "",
            isConditionMet: field.isConditionMet,
            isRequired: field.isRequired || false,
            label: field.label,
            isVisible: field.visible || true,
            dataName: field.dataName || "",
            selectedLabelPosition: field.selectedLabelPosition || "",
            visible: field.isVisibleIf ? false : field.visible || true,
            isVisibleIf: field.isVisibleIf,
            uploadFileSize: field.uploadFileSize || "",
            uploadFileType: field.uploadFileType ? [...field.uploadFileType] : [],
          };
        } else if (dataName.startsWith("lastName")) {
          updatedFormData[dataName] = {
            value: prefillData.last_name || "",
            isConditionMet: field.isConditionMet,
            isRequired: field.isRequired || false,
            label: field.label,
            isVisible: field.visible || true,
            dataName: field.dataName || "",
            selectedLabelPosition: field.selectedLabelPosition || "",
            visible: field.isVisibleIf ? false : field.visible || true,
            isVisibleIf: field.isVisibleIf,
            uploadFileSize: field.uploadFileSize || "",
            uploadFileType: field.uploadFileType ? [...field.uploadFileType] : [],
          };
        } else if (dataName.startsWith("emailDef")) {
          updatedFormData[dataName] = {
            value: prefillData.email || "",
            isConditionMet: field.isConditionMet,
            isRequired: field.isRequired || false,
            label: field.label,
            isVisible: field.visible || true,
            dataName: field.dataName || "",
            selectedLabelPosition: field.selectedLabelPosition || "",
            visible: field.isVisibleIf ? false : field.visible || true,
            isVisibleIf: field.isVisibleIf,
            uploadFileSize: field.uploadFileSize || "",
            uploadFileType: field.uploadFileType ? [...field.uploadFileType] : [],
          };
        } else if (dataName.startsWith("countryDef")) {
          updatedFormData[dataName] = {
            value: prefillData.country || "",
            isConditionMet: field.isConditionMet,
            isRequired: field.isRequired || false,
            label: field.label,
            isVisible: field.visible || true,
            dataName: field.dataName || "",
            selectedLabelPosition: field.selectedLabelPosition || "",
            visible: field.isVisibleIf ? false : field.visible || true,
            isVisibleIf: field.isVisibleIf,
            uploadFileSize: field.uploadFileSize || "",
            uploadFileType: field.uploadFileType ? [...field.uploadFileType] : [],
          };
        } else {
          updatedFormData[dataName] = {
            value: field.defaultValue || "",
            isConditionMet: field.isConditionMet,
            isRequired: field.isRequired || false,
            label: field.label,
            isVisible: field.visible || true,
            dataName: field.dataName || "",
            selectedLabelPosition: field.selectedLabelPosition || "",
            visible: field.isVisibleIf ? false : field.visible || true,
            isVisibleIf: field.isVisibleIf,
            uploadFileSize: field.uploadFileSize || "",
            uploadFileType: field.uploadFileType ? [...field.uploadFileType] : [],
          };
        }
      });

      setFormData((prev) => ({
        ...prev,
        ...updatedFormData,
      }));

      hasPrefilledOnce.current = true;
      setIsLoading(false);

    }, 2000);
    return () => clearTimeout(timeoutId);

  }, [prefillData, formSchema]);

  useEffect(() => {
    if (formSchema.length > 0) {
      const initialData = formSchema.reduce((acc, field) => {
        acc[field.dataName] = {
          value: field.defaultValue || "",
          isConditionMet: field.isConditionMet,
          isRequired: field.isRequired || false,
          label: field.label,
          isVisible: field.visible || true,
          dataName: field.dataName || "",
          selectedLabelPosition: field.selectedLabelPosition || "",
          visible: field.isVisibleIf ? false : field.visible || true, // Set visible to false if isVisibleIf is true
          isVisibleIf: field.isVisibleIf,
          uploadFileSize: field.uploadFileSize || "",
          uploadFileType: field.uploadFileType ? [...field.uploadFileType] : [],
        };
        return acc;
      }, {});
      setFormData(initialData);
    }
  }, [formSchema]);


  const handleInputChange = (dataName, value) => {
    setFormData((prevData) => {
      const updatedData = {
        ...prevData,
        [dataName]: {
          ...prevData[dataName],
          value,
        },
      };
      return updatedData;
    });
  };
  const handleRadioAndDropDown = (name, value) => {
    setFormData((prev) => ({
      ...prev,
      [name]: {
        ...prev[name],
        value,
      },
    }));
  };

  const handleCheckboxChange = (name, option) => {
    setFormData((prev) => {
      const currentValue = prev[name]?.value;

      return {
        ...prev,
        [name]: {
          ...prev[name],
          value: currentValue === option ? "" : option, // Store single option as string
        },
      };
    });
  };

  const handlePosition = () => {
    formSchema.forEach((field) => {
      const { selectedLabelPosition, dataName } = field;
      const fieldToCheck = formData[dataName];

      if (
        fieldToCheck &&
        fieldToCheck.selectedLabelPosition !== selectedLabelPosition
      ) {
        const updatedFormData = {
          ...formData,
          [dataName]: {
            ...fieldToCheck,
            selectedLabelPosition: selectedLabelPosition,
          },
        };
        setFormData(updatedFormData);
      }
    });
  };

  const handleFileChange = async (event, dataName) => {
    const file = event.target.files[0];
    if (!file) return;

    const field = formData[dataName];
    if (!field) return;

    const maxSizeMB = parseFloat(field.uploadFileSize) || 10; // Default to 10 MB if not specified
    const allowedTypes = field.uploadFileType || []; // Allowed extensions

    // Check file size
    const fileSizeMB = file.size / (1024 * 1024);
    if (fileSizeMB > maxSizeMB) {
      toast.error(`File size should not exceed ${maxSizeMB} MB`);
      return;
    }

    // Check file type
    const fileExtension = `.${file.name.split(".").pop()}`.toLowerCase();
    if (allowedTypes.length > 0 && !allowedTypes.includes(fileExtension)) {
      toast.error(
        `Invalid file type. Allowed types: ${allowedTypes.join(", ")}`
      );
      return;
    }

    // Compress image files (if applicable)
    let processedFile = file;
    if (file.type.startsWith("image/")) {
      try {
        const options = {
          maxSizeMB: maxSizeMB, // Maximum size in MB
          maxWidthOrHeight: 1024, // Resize to 1024px width or height
          useWebWorker: true, // Use web worker for better performance
        };
        processedFile = await imageCompression(file, options);
      } catch (error) {
        console.error("Error compressing image:", error);
        toast.error("Failed to compress image. Please try again.");
        return;
      }
    }

    // Check file size again after compression
    const processedFileSizeMB = processedFile.size / (1024 * 1024);
    if (processedFileSizeMB > maxSizeMB) {
      toast.error(
        `File size after compression exceeds ${maxSizeMB} MB. Please upload a smaller file.`
      );
      return;
    }

    // Convert file to Base64 and update formData
    const reader = new FileReader();
    reader.readAsDataURL(processedFile);
    reader.onloadend = () => {
      // setFormData((prevData) => ({
      //   ...prevData,
      //   [dataName]: {
      //     ...prevData[dataName],
      //     value: reader.result, // Store Base64 string in form data
      //     valid: true, // Mark file as valid
      //   },
      // }));
      toast.success("File uploaded successfully.");
    };
  };

  const checkRequiredCondition = () => {
    let updated = false; // Flag to track if any update has occurred
    formSchema.forEach((field) => {
      const {
        requiredFieldValue,
        requiredConditionValue,
        dataName,
        requiredCondition = "Equals ",
      } = field;

      if (!requiredFieldValue || !requiredConditionValue) return;

      // Find the field to check its value against the condition
      const fieldToCheck = Object.values(formData).find(
        (field) => field.label === requiredFieldValue
      );
      const relatedFieldKey = dataName;
      const relatedField = formData[dataName];

      if (fieldToCheck) {
        let conditionMet = false;

        switch (requiredCondition) {
          case "Equals":
            conditionMet = fieldToCheck.value === requiredConditionValue;
            break;

          case "contains":
            conditionMet = fieldToCheck.value.includes(requiredConditionValue);
            break;

          case "startsWith":
            conditionMet = fieldToCheck.value.startsWith(
              requiredConditionValue
            );
            break;

          case "endsWith":
            conditionMet = fieldToCheck.value.endsWith(requiredConditionValue);
            break;

          case "not-contains":
            conditionMet = !fieldToCheck.value.includes(requiredConditionValue);
            break;

          case "not-startsWith":
            conditionMet = !fieldToCheck.value.startsWith(
              requiredConditionValue
            );
            break;

          case "not-endsWith":
            conditionMet = !fieldToCheck.value.endsWith(requiredConditionValue);
            break;

          default:
            conditionMet = fieldToCheck.value === requiredConditionValue;
        }

        // Only update if the required state has changed
        if (conditionMet) {
          if (relatedField && !relatedField.isRequired) {
            const updatedFormData = {
              ...formData,
              [dataName]: {
                ...relatedField,
                isRequired: true,
              },
            };
            if (
              !updated &&
              JSON.stringify(formData[dataName].isRequired) !==
              JSON.stringify(updatedFormData[dataName].isRequired)
            ) {
              setFormData(updatedFormData);
              updated = true;
            }
          }
        } else {
          if (relatedField && relatedField.isRequired) {
            const updatedFormData = {
              ...formData,
              [dataName]: {
                ...relatedField,
                isRequired: false,
              },
            };
            if (
              !updated &&
              JSON.stringify(formData[dataName].isRequired) !==
              JSON.stringify(updatedFormData[dataName].isRequired)
            ) {
              setFormData(updatedFormData);
              updated = true;
            }
          }
        }
      }
    });

    if (!updated) {
      return;
    }
  };

  const checkVisibilityCondition = () => {
    formSchema.forEach((fieldPayloadItem) => {
      const {
        visibleFieldValue = "",
        visibleConditionValue = "",
        dataName = "",
        visibleCondition = "Equals",
        isVisibleIf = true,
      } = fieldPayloadItem;

      // Skip if required fields are missing
      if (!visibleFieldValue || !visibleConditionValue || !dataName) return;

      const relatedFieldKey = dataName;
      const relatedField = formData[relatedFieldKey];

      // Skip if the related field doesn't exist
      if (!relatedField) return;

      // Find the field to check for the condition
      const fieldToCheck = Object.values(formData).find(
        (field) => field.dataName === visibleFieldValue
      );

      // Skip if the field to check doesn't exist
      if (!fieldToCheck) return;

      // Evaluate the visibility condition
      let conditionMet = false;

      switch (visibleCondition) {
        case "Equals":
          conditionMet = fieldToCheck.value === visibleConditionValue;
          break;

        case "contains":
          conditionMet = fieldToCheck.value.includes(visibleConditionValue);
          break;

        case "startsWith":
          conditionMet = fieldToCheck.value.startsWith(visibleConditionValue);
          break;

        case "endsWith":
          conditionMet = fieldToCheck.value.endsWith(visibleConditionValue);
          break;

        case "not-contains":
          conditionMet = !fieldToCheck.value.includes(visibleConditionValue);
          break;

        case "not-startsWith":
          conditionMet = !fieldToCheck.value.startsWith(visibleConditionValue);
          break;

        case "not-endsWith":
          conditionMet = !fieldToCheck.value.endsWith(visibleConditionValue);
          break;

        default:
          conditionMet = fieldToCheck.value === visibleConditionValue;
      }

      // Determine the new visibility state
      const newVisibility = isVisibleIf ? conditionMet : relatedField.visible;

      // Update the formData only if the visibility has changed
      if (relatedField.visible !== newVisibility) {
        setFormData((prevFormData) => ({
          ...prevFormData,
          [relatedFieldKey]: {
            ...relatedField,
            visible: newVisibility,
          },
        }));
      }
    });
  };


  useEffect(() => {
    checkRequiredCondition();
    checkVisibilityCondition();
    handlePosition();
  }, [formSchema, formData]);

  const handleRadioChange = (fieldName, value) => {
    setFormData({
      ...formData,
      [fieldName]: value,
    });
  };

  const renderField = (field) => {
    const relatedField = formData[field.dataName];
    if (!relatedField?.isConditionMet) return null;
    const requiredConditionMet = checkRequiredCondition(field);
    const fieldClass = relatedField?.visible ? "show" : "hide";

    handlePosition(relatedField);
    const labelPositionLeft = relatedField?.selectedLabelPosition === "left";

    // const fieldWidth = field.fieldSize || "100%";

    const fieldPayloadItem = formSchema?.find(
      (item) => item.dataName === field.dataName
    );
    const fieldWidth = fieldPayloadItem?.selectedFieldSize || "100%";

    const fieldStyle = {
      display: "flex",
      flexDirection: labelPositionLeft ? "row" : "column",
      alignItems: labelPositionLeft ? "center" : "flex-start",
    };

    const labelStyle = {
      marginRight: labelPositionLeft ? "10px" : "0",
      width: labelPositionLeft ? "55%" : "auto",
      textAlign: labelPositionLeft ? "left" : "center",
    };

    const inputStyle = {
      width: fieldWidth,
      marginLeft: labelPositionLeft ? "0" : "0",
    };

    const labelText = field.label || relatedField?.label;
    let hasRendered = false;

    const hoverHint =
      (formSchema &&
        formSchema.find((item) => item.dataName === field.dataName)
          ?.hoverHint) ||
      "";

    if (!relatedField.visible) return null;
    if (!field.isVisibleIf && !field.visible) return null;

    return (
      <div className={relatedField.visible ? "show" : "hide"}>
        <div key={field.dataName} className="form-field" style={fieldStyle}>
          <label style={labelStyle}>
            {labelText}
            {(relatedField?.isRequired ||
              (relatedField?.isRequired === false &&
                formSchema?.some(
                  (item) =>
                    item.dataName === field.dataName &&
                    (!item.requiredConditionValue ||
                      item.requiredConditionValue.trim() === "") &&
                    item.required
                ))) && <span style={{ color: "red" }}>*</span>}
            {hoverHint && (
              <span className="hover-hint-icon" title={hoverHint}>
                ?
              </span>
            )}
          </label>

          {(() => {
            switch (field.type) {
              case "text":
                if (!hasRendered) {
                  hasRendered = true;
                  return (
                    <InputType
                      type="text"
                      placeholder={field.placeholder || ""}
                      value={relatedField?.value || ""}
                      onChange={(e) =>
                        handleInputChange(field.dataName, e.target.value)
                      }
                      required={
                        requiredConditionMet || relatedField?.isRequired
                      }
                      style={inputStyle}
                    />
                  );
                }
                break;
              case "email":
                if (!hasRendered) {
                  hasRendered = true;
                  return (
                    <InputType
                      type="email"
                      placeholder={field.placeholder || ""}
                      value={relatedField?.value || ""}
                      onChange={(e) =>
                        handleInputChange(field.dataName, e.target.value)
                      }
                      required={
                        requiredConditionMet || relatedField?.isRequired
                      }
                      style={inputStyle}
                    />
                  );
                }
                break;
              case "date":
                if (!hasRendered) {
                  hasRendered = true;
                  return (
                    <InputType
                      type="date"
                      value={relatedField?.value || ""}
                      onChange={(e) =>
                        handleInputChange(field.dataName, e.target.value)
                      }
                      required={
                        requiredConditionMet || relatedField?.isRequired
                      }
                      style={inputStyle}
                    />
                  );
                }
                break;
              case "country":
                if (!hasRendered) {
                  hasRendered = true;
                  return (
                    <SelectBorder
                      value={formData[field.dataName]?.value || ""}
                      onChange={(e) =>
                        handleInputChange(field.dataName, e.target.value)
                      }
                      required={
                        requiredConditionMet ||
                        formData[field.dataName]?.isRequired
                      }
                      style={inputStyle}
                    >
                      <option value="">Select a country</option>
                      {countries.map((country, index) => (
                        <option key={index} value={country}>
                          {country}
                        </option>
                      ))}
                    </SelectBorder>
                  );
                }
                break;
              case "email":
                if (!hasRendered) {
                  hasRendered = true;
                  return (
                    <InputType
                      type="email"
                      placeholder={field.placeholder || ""}
                      value={relatedField?.value || ""}
                      onChange={(e) =>
                        handleInputChange(field.dataName, e.target.value)
                      }
                      required={
                        requiredConditionMet || relatedField?.isRequired
                      }
                      style={inputStyle}
                    />
                  );
                }
                break;
              case "textarea":
                if (!hasRendered) {
                  hasRendered = true;
                  return (
                    <InputTextarea
                      placeholder={
                        field.placeholder || field.defaultValue || ""
                      }
                      value={relatedField?.value || ""}
                      onChange={(e) =>
                        handleInputChange(field.dataName, e.target.value)
                      }
                      required={
                        requiredConditionMet || relatedField?.isRequired
                      }
                      style={{ ...inputStyle, height: "100px" }}
                    />
                  );
                }
                break;
              case "text":
                if (!hasRendered) {
                  hasRendered = true;
                  return (
                    <inputStyle
                      type="text"
                      placeholder={field.placeholder || ""}
                      value={relatedField?.value || ""}
                      onChange={(e) =>
                        handleInputChange(field.dataName, e.target.value)
                      }
                      required={
                        requiredConditionMet || relatedField?.isRequired
                      }
                      style={inputStyle}
                    />
                  );
                }
                break;

              case "text":
                if (!hasRendered) {
                  hasRendered = true;
                  return (
                    <inputStyle
                      type="text"
                      placeholder={field.placeholder || ""}
                      value={relatedField?.value || ""}
                      onChange={(e) =>
                        handleInputChange(field.dataName, e.target.value)
                      }
                      // required={
                      //   requiredConditionMet || relatedField?.isRequired
                      // }
                      style={inputStyle}
                    />
                  );
                }
                break;
              case "file":
                if (!hasRendered) {
                  hasRendered = true;
                  return (
                    <InputType
                      type="file"
                      onChange={(event) =>
                        handleFileChange(event, field.dataName)
                      }
                      required={
                        requiredConditionMet || relatedField?.isRequired
                      }
                      style={inputStyle}
                    />
                  );
                }
                break;
              case "radio":
                if (!hasRendered) {
                  hasRendered = true;
                  return (
                    <>
                      {field.options &&
                        field.options.map((option, index) => (
                          <div key={index} className="sub_form_preview_radio">
                            <InputType
                              type="radio"
                              name={field.dataName}
                              value={option}
                              checked={relatedField?.value === option}
                              onChange={() =>
                                handleRadioAndDropDown(field.dataName, option)
                              }
                              required={
                                requiredConditionMet || relatedField?.isRequired
                              }
                              style={inputStyle}
                            />
                            <label>{option}</label>
                          </div>
                        ))}
                    </>
                  );
                }
                break;
              case "checkbox":
                if (!hasRendered) {
                  hasRendered = true;
                  return (
                    <>
                      {field.options &&
                        field.options.map((option, index) => (
                          <div key={index} className="sub_form_preview_radio">
                            <InputType
                              type="checkbox"
                              name={field.dataName}
                              value={option}
                              checked={relatedField?.value === option}
                              onChange={() =>
                                handleCheckboxChange(field.dataName, option)
                              }
                              required={
                                requiredConditionMet || relatedField?.isRequired
                              }
                              style={inputStyle}
                            />
                            <label>{option}</label>
                          </div>
                        ))}
                    </>
                  );
                }
                break;
              case "dropdown":
                if (!hasRendered) {
                  hasRendered = true;

                  return (
                    <SelectBorder
                      value={relatedField?.value || ""}
                      onChange={(e) =>
                        handleRadioAndDropDown(field.dataName, e.target.value)
                      }
                      required={
                        requiredConditionMet || relatedField?.isRequired
                      }
                      style={inputStyle}
                    >
                      {field.options &&
                        field.options.map((option, index) => (
                          <option key={index} value={option}>
                            {option}
                          </option>
                        ))}
                    </SelectBorder>
                  );
                }
                break;
              case "tel":
                if (!hasRendered) {
                  hasRendered = true;
                  return (
                    <InputType
                      type="number"
                      placeholder={field.placeholder || "Enter phone number"}
                      value={relatedField?.value || ""}
                      onChange={(e) =>
                        handleInputChange(field.dataName, e.target.value)
                      }
                      required={
                        requiredConditionMet || relatedField?.isRequired
                      }
                      style={inputStyle}
                    />
                  );
                }
                break;
              case "country":
                if (!hasRendered) {
                  hasRendered = true;
                  return (
                    <SelectBorder
                      value={relatedField?.value || ""}
                      onChange={(e) =>
                        handleInputChange(field.dataName, e.target.value)
                      }
                      required={
                        requiredConditionMet || relatedField?.isRequired
                      }
                      style={inputStyle}
                    >
                      <option value="">Select a country</option>
                      {countries.map((country, index) => (
                        <option key={index} value={country}>
                          {country}
                        </option>
                      ))}
                    </SelectBorder>
                  );
                }
                break;
              default:
                return null;
            }
          })()}

          {errors[field.dataName] && (
            <p style={{ color: "red", fontSize: "12px" }}>
              {errors[field.dataName]}
            </p>
          )}
        </div>
      </div>
    );
  };
  const convertFormDataToSimpleObject = (formData) => {
    const result = {};

    Object.entries(formData).forEach(([key, value]) => {
      if (value && value.value) {
        const keyWithoutTimestamp = key; // Remove the timestamp part
        result[keyWithoutTimestamp] = value.value;
      }
    });

    return result;
  };

  const saveForm = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      let formIsValid2 = true;

      Object.keys(formData).forEach((key) => {
        const field = formData[key];
        if (field?.type === "file" && (!field.value || !field.valid)) {
          formIsValid2 = false;
          toast.error(`Invalid file in ${key}: Check size and type.`);
        }
      });

      if (!formIsValid2) {
        console.log("Form contains invalid file fields.");
        return;
      }

      const formIsValid = Object.values(formData).every((field) => {
        if (field.isRequired && !field.value) {
          console.log(`Field ${field.label} is required but empty`);
          toast.error(`Field ${field.label} is required but empty`);
          return false;
        }
        return true;
      });

      if (!formIsValid) {
        console.log("Form is invalid");
        return;
      }

      console.log("Form is valid, proceed with submission!");

      const convertedData = convertFormDataToSimpleObject(formData);

      const formPayload = {
        fields: convertedData,
        eventId,
        registrationFormId,
      };

      const response = await axios.post(
        `${EXCHNAGE_URL}/registrationForm_submission`,
        formPayload,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      console.log(response, "response");
      toast.success("Registration Form Submitted Successfully.");
      navigate("/user-submission-details", {
        state: {
          eventId: eventId,
          entryFormId: entryFormId,
          event_logo: event_logo,
          event_banner: event_banner,
          closing_date: closing_date,
          closing_time: closing_time,
          event_name: event_name,
        },
      });
    } catch (error) {
      console.error("Error creating form:", error);
      toast.error("Error creating form. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const formIsValid = Object.values(formData).every((field) => {
      if (field.isRequired && !field.value) {
        console.log(`Field ${field.label} is required but empty`);
        return false;
      }
      return true;
    });

    if (formIsValid) {
      console.log("Form is valid, proceed with submission!");
    } else {
      console.log("Form is invalid");
      setLoading(false);
    }
  };
  return (

    <>
      {isLoading ? (<div className="fullscreen-loaderr">
        <div className="loaderr"></div>
      </div>) :
        (<>
          <UserTopBanner
            event_logo={event_logo}
            event_banner={event_banner}
            closing_date={closing_date}
            closing_time={closing_time}
            event_name={event_name}
          />
          <div className="registration_form_main">
            <div className="registration_form">
              <RedMainHeading>Registration Form</RedMainHeading>
            </div>
            <form className="registration_form_div" onSubmit={handleSubmit}>
              <div className="registration_form_row">
                {formSchema.map((field) => {
                  const relatedField = formData[field.dataName];
                  const shouldShow = relatedField?.visible;

                  if (!shouldShow) return null;

                  return (
                    <div key={field.dataName} className="registration_form_label">
                      {renderField(field)}
                    </div>
                  );
                })}
              </div>

              <div className="registration_form_btn_div">
                {formSchema.length > 0 ? (
                  <>
                    <GreyBorderButton type="button" onClick={openCancelModal}>
                      Cancel
                    </GreyBorderButton>

                    <RedBackgroundButton type="submit" onClick={saveForm}>
                      Submit
                    </RedBackgroundButton>
                  </>
                ) : (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                    }}
                  >
                    <p
                      style={{
                        color: "red",
                        fontWeight: "bold",
                        textAlign: "center",
                      }}
                    >
                      You have Already Submitted the registration form kindly
                      continue with entry form
                    </p>
                    <div>
                      <GreyBorderButton type="button" onClick={openCancelModal}>
                        Cancel
                      </GreyBorderButton>
                      <GreyBorderButton type="button" onClick={() => {
                        navigate("/user-submission-details", {
                          state: {
                            eventId: eventId,
                            entryFormId: entryFormId,
                            event_logo: event_logo,
                            event_banner: event_banner,
                            closing_date: closing_date,
                            closing_time: closing_time,
                            event_name: event_name,
                          },
                        });
                      }}>
                        Next
                      </GreyBorderButton>
                    </div>
                  </div>
                )}
              </div>
            </form>
          </div>
          <Modal show={isCancelModalOpen} onHide={closeCancelModal} centered>
            <Modal.Header closeButton>
              <Modal.Title>Confirm Cancellation</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <p>Are you sure you want to cancel? Your changes will be lost.</p>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={closeCancelModal}>
                No, Keep Editing
              </Button>
              <Button variant="danger" onClick={handleCancel}>
                Yes, Cancel
              </Button>
            </Modal.Footer>
          </Modal>
          <UserBottomBar />
        </>)}

    </>
  );
};
